export default "__VITE_ASSET__BfPihqE8__"